module.exports = __webpack_public_path__ + "static/blog09-199346766c8ef8c87f3128a309168f2e.png";